import React, { useEffect, useState } from "react";
import { getStates } from "../actions";

const useGetStateFromACountries = ({ countriesList }) => {
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!countriesList?.length) {
      setStates([]);
      setLoading(false);
      return;
    }

    const fetchStates = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getStates(countriesList);
        setStates(response);
      } catch (err) {
        setError(err);
        setStates([]);
      } finally {
        setLoading(false);
      }
    };

    fetchStates();
  }, [countriesList]);

  return { states, loading, error };
};

export default useGetStateFromACountries;
